const oil = 'https://ik.imagekit.io/sbrqdqxneo/Banners/oil-change.jpg?updatedAt=1759418568182';
const carElectronics =
  'https://ik.imagekit.io/sbrqdqxneo/Banners/car-electronics.jpg?updatedAt=1759423387055';
const carEngine =
  'https://ik.imagekit.io/sbrqdqxneo/Banners/car-engine-crop.jpg?updatedAt=1759423572892';
const carRepair =
  'https://ik.imagekit.io/sbrqdqxneo/Banners/car-repair.jpg?updatedAt=1759418568440';
export { oil, carElectronics, carEngine, carRepair };
